import {
    UniformSlotWrapperComponentProps,
    UniformSlot
} from "@uniformdev/canvas-react";

import { Button } from "@/libraries/design/components";
import { CtaWithPolygonBackground } from "@/libraries/design/patterns/cta-with-polygon-background/cta-with-polygon-background.tsx";
import { useLocalizedHref } from "@/libraries/web-framework/index.ts";

type UniformCtaWithPolygonBackgroundProps = {
    title: string;
    description?: string;
    ctaText?: string;
    ctaUrl?: string;
};

export const UniformCtaWithPolygonBackground = (
    props: UniformCtaWithPolygonBackgroundProps
) => {
    const localizedHref = useLocalizedHref(props.ctaUrl ?? "");

    const button = () => {
        if (
            props.ctaText &&
            props.ctaText !== "" &&
            props.ctaUrl &&
            props.ctaUrl !== ""
        ) {
            return <Button href={localizedHref}>{props.ctaText}</Button>;
        }
        return;
    };

    return (
        <CtaWithPolygonBackground
            header={props.title}
            paragraph={props.description}
            button={button() ?? <UniformSlot name="ctaButton" />}
        />
    );
};
